import axios from 'axios';
export const HTTP = axios.create({
  baseURL:window.process.env.API_HOST_GLOBAL,
  headers: {
    Authorization: window.ApiToken ? window.ApiToken : 'Bearer ' +process.env.API_TOKEN,
  },
});

export default function getHttp() {
  axios.create({
    baseURL:window.process.env.API_HOST_GLOBAL,
    headers: {
      Authorization: window.ApiToken ? window.ApiToken : 'Bearer ' +process.env.API_TOKEN,
    },
  });
}



// WEBPACK FOOTER //
// ./src/core/http/http-common.js